/* Harold Speelhuisjes, afstandsmelding bij adresvelden.
   Toont een vriendelijke, niet-blokkerende melding als het ingevulde adres buiten
   het vaste werkgebied valt (ca. 2,5 tot 3 uur rijden vanaf Schaijk).
   Werkt in de offerteconfigurator en in de ontwerper, in het Nederlands en Duits.
   Nederland en Belgie vallen altijd binnen het werkgebied. */
(function(){
'use strict';
var DE_DICHTBIJ=['26','32','33','40','41','42','44','45','46','47','48','49','50','51','52','53','54','56','57','58','59'];
var LANG=((document.documentElement.getAttribute('lang')||'nl').slice(0,2).toLowerCase()==='de')?'de':'nl';
var TXT={
 nl:{t:'Dat is een flinke afstand vanaf onze werkplaats in Schaijk.',b:'Plaatsen kan vaak nog steeds, maar het transport kost dan meer en het moet in onze planning passen. Verstuur gerust je aanvraag, dan laten we je eerlijk weten wat mogelijk is en wat het transport kost.',
     ok:'Goed nieuws: op dit adres leveren en plaatsen we.'},
 de:{t:'Das ist eine gr\u00f6\u00dfere Entfernung von unserer Werkstatt in Schaijk.',b:'Ein Aufbau ist oft trotzdem m\u00f6glich, der Transport kostet dann aber mehr und es muss in unsere Planung passen. Senden Sie Ihre Anfrage gerne ab, wir sagen Ihnen ehrlich, was m\u00f6glich ist und was der Transport kostet.',
     ok:'Gute Nachricht: An diese Adresse liefern und montieren wir.'}
};
function landVan(v){ v=String(v||'').trim().toLowerCase(); if(!v) return ''; if(/^(de|deu|deutschland|duitsland|germany)$/.test(v)) return 'DE'; if(/^(be|bel|belgi|belgie|belgi\u00eb|belgien|belgium)/.test(v)) return 'BE'; if(/^(nl|nld|nederland|niederlande|netherlands)$/.test(v)) return 'NL'; return v.toUpperCase().slice(0,2); }
// Geeft 'ver' (buiten het werkgebied), 'ok' (Duits adres binnen het werkgebied) of '' (geen melding).
function status(land,pc){
  pc=String(pc||'').replace(/\s+/g,'').toUpperCase(); if(!pc) return '';
  if(/^\d{5}$/.test(pc)) land='DE'; // 5 cijfers is altijd een Duitse postcode
  if(!land||land==='NL'||land==='BE') return '';
  if(land==='DE'){ if(!/^\d{5}$/.test(pc)) return ''; return DE_DICHTBIJ.indexOf(pc.slice(0,2))===-1?'ver':'ok'; }
  return 'ver'; // ander land: altijd op aanvraag
}
function isVer(land,pc){ return status(land,pc)==='ver'; }
var STIJL='margin:8px 0 12px;padding:10px 12px;border-radius:4px;font-size:14px;line-height:1.5;color:#3D2A1C;';
function melding(){ var d=document.createElement('div'); d.className='hs-afstand'; d.setAttribute('role','status'); d.hidden=true; return d; }
function toon(box,st){
  if(box.__st===st) return; box.__st=st;
  if(!st){ box.hidden=true; return; }
  if(st==='ok'){ box.style.cssText=STIJL+'border-left:3px solid #4F7A3A;background:#EEF4EA'; box.innerHTML='<strong>\u2713 '+TXT[LANG].ok+'</strong>'; }
  else { box.style.cssText=STIJL+'border-left:3px solid #B0642C;background:#FAF3EA'; box.innerHTML='<strong>'+TXT[LANG].t+'</strong><br>'+TXT[LANG].b; }
  box.hidden=false;
}
function zoekLand(form){
  var s=form.querySelector('select[name*="land" i],select[name*="country" i],select[id*="land" i],select[id*="country" i]');
  if(s) return s;
  var all=form.querySelectorAll('select'); for(var i=0;i<all.length;i++){ var t=all[i].textContent.toLowerCase(); if(/(nederland|niederlande)/.test(t)&&/(belgi|deutschland|duitsland)/.test(t)) return all[i]; }
  return null;
}
function koppel(pcInput){
  if(!pcInput||pcInput.__hsAfstand) return; pcInput.__hsAfstand=true;
  var form=pcInput.closest('form')||pcInput.closest('[data-form]')||document;
  var landSel=zoekLand(form);
  var box=melding(); var anker=pcInput.closest('.ho-row-2')||pcInput.closest('.hsow-two')||pcInput.closest('.hsow-row')||pcInput.parentNode;
  anker.parentNode.insertBefore(box,anker.nextSibling);
  function check(){ var land=landSel?landVan(landSel.value||(landSel.options[landSel.selectedIndex]||{}).text):''; toon(box,status(land,pcInput.value)); }
  pcInput.addEventListener('input',check); pcInput.addEventListener('change',check); pcInput.addEventListener('blur',check);
  if(landSel) landSel.addEventListener('change',check);
  check();
}
function scan(root){
  var l=(root||document).querySelectorAll('input[name*="postcode" i],input[name*="postleitzahl" i],input[name*="zip" i],input[autocomplete="postal-code"]');
  for(var i=0;i<l.length;i++) koppel(l[i]);
}
window.HSAfstand={status:status,isVer:isVer,landVan:landVan};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ scan(); }); else scan();
// De ontwerper tekent zijn formulier pas in stap 3; daarom blijven we nieuwe velden oppikken.
new MutationObserver(function(){ scan(); }).observe(document.documentElement,{childList:true,subtree:true});
})();
